import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const BASE = "w-full bg-white border border-navy/10 rounded-lg px-3 py-2.5 text-sm h-auto";

// Drop-in shadcn Select. options = [{value,label}]. onChange recibe el value.
// Evita <option> nativo → sin warning de hidratación en el editor de preview.
export default function SelectField({ value, onChange, options = [], placeholder, testid, className }) {
  return (
    <Select value={value ?? undefined} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className={className || BASE}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {options.map((o) => <SelectItem key={String(o.value)} value={String(o.value)}>{o.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
